module.exports = __webpack_public_path__ + "img/date_ddatemintone.3c5f0af.png";